import { hasQuestionLabelHtml } from 'utils/question-label';
import { RichTextPreview } from 'components/rich-text-preview';

import { QuestionLabelProps } from './types';

export const QuestionLabel = ({ value }: QuestionLabelProps) => {
  // Preserve the layout and whitespace behavior of legacy plain labels.
  if (!value || !hasQuestionLabelHtml(value)) return <>{value}</>;
  return <RichTextPreview inline content={value} allowImages={false} />;
};
